import React from 'react';

const renderInput = (field, value, onChange) => {
  const common = {
    name: field.name,
    value: value ?? (field.type === 'number' ? 0 : ''),
    onChange: (e) => onChange(e.target.value),
    className: field.type === 'select' ? 'email-select'
      : field.type === 'textarea' ? 'email-textarea'
      : 'email-input',
    ...(field.testid ? { 'data-testid': field.testid } : {}),
    ...(field.placeholder ? { placeholder: field.placeholder } : {}),
  };

  if (field.type === 'select') {
    return (
      <select {...common}>
        {field.options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    );
  }
  if (field.type === 'textarea') {
    return <textarea {...common} rows={field.rows || 3} />;
  }
  if (field.type === 'number') {
    return <input type="number" min={field.min} step={field.step} {...common} />;
  }
  return <input type={field.type} {...common} />;
};

const SponsorFormField = ({ field, value, onChange }) => (
  <label style={{ color: '#fff', ...(field.fullWidth ? { gridColumn: '1 / -1' } : {}) }}>
    {field.label}
    {renderInput(field, value, onChange)}
  </label>
);

export default SponsorFormField;
